/**
 * PATH: packages/pricelist/src/PricelistMobileTips.tsx
 * FILE_ID: PKG-PRICELIST-MOBILE-TIPS-001
 * PURPOSE: Short phone gesture tips for pricelist Excel-parity menus.
 * WHY: Touch users need a one-line hint for long-press / ⋯; keep it brief.
 */
export default function PricelistMobileTips() {
  return (
    <p
      className="qb-pl-mobile-tips text-xs text-slate-500 dark:text-slate-400"
      data-testid="pricelist-mobile-tips"
    >
      Tip: long-press a row or tap <span aria-hidden="true">⋯</span> for insert /
      duplicate / delete. Long-press a column header to hide or manage columns.
    </p>
  )
}
